import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { DescriptionOutlined } from '@mui/icons-material';
import { useFacilityMaintenanceEditor } from '../../../../../hooks/useFacilityMaintenanceEditor';
import { EditorMode } from '../../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const FacilityMaintenanceDescriptionEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useFacilityMaintenanceEditor(mode);

  const handleChange = (value: string) => {
    updateRequest({ description: value });
  };

  return (
    <TextField
      label="Maintenance Description"
      value={request?.description || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      required
      multiline
      rows={4}
      placeholder="Describe the maintenance request in detail"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <DescriptionOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FacilityMaintenanceDescriptionEditor;
